import AxiosService from '../AxiosService';
import { apiUrl } from '../config/globals';

export const uploadImages = async (data) => AxiosService.post(`${apiUrl('file')}/upload-image`, data);
